import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

// Information badge (type, schedule, "New"). Not for status: use GrStatusPill for that.
const TONES = {
  neutral: { fg: gr.color.muted, bg: gr.color.bg, border: gr.color.line },
  brand: {
    fg: gr.color.brandDark,
    bg: gr.color.brandSoft,
    border: "transparent",
  },
  ok: { fg: gr.color.ok, bg: gr.color.okSoft, border: "transparent" },
  // Teal outline: a role/label that should stand apart from `brand` without using status colours.
  outline: {
    fg: gr.color.brandDark,
    bg: gr.color.surface,
    border: gr.color.brand,
  },
};

export default function GrBadge({
  tone = "neutral",
  icon,
  children,
  sx,
  ...rest
}) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: gr.space[1],
        padding: `2px ${gr.space[2]}`,
        borderRadius: gr.radius.pill,
        border: `1px solid ${t.border}`,
        background: t.bg,
        color: t.fg,
        fontFamily: gr.font.family,
        fontSize: gr.font.size.xs,
        fontWeight: gr.font.weight.medium,
        lineHeight: 1.5,
        whiteSpace: "nowrap",
        "& svg": { width: 14, height: 14 },
        ...sx,
      }}
      {...rest}
    >
      {icon}
      {children}
    </Box>
  );
}

GrBadge.propTypes = {
  tone: PropTypes.oneOf(Object.keys(TONES)),
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};
